import dayjs from 'dayjs';

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '-';
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm') : '-';
}

export function formatProjectReportDate(
  reportDate: string | null | undefined,
  createdAt: string | null | undefined,
  reportPeriod: 'DAILY' | 'WEEKLY' | 'MONTHLY',
): string {
  const report = dayjs(reportDate);
  if (!report.isValid()) {
    return formatDate(createdAt);
  }

  const created = dayjs(createdAt);
  if (
    reportPeriod === 'WEEKLY' &&
    created.isValid() &&
    report.startOf('day').isAfter(created.startOf('day'))
  ) {
    return created.format('YYYY-MM-DD');
  }

  return report.format('YYYY-MM-DD');
}
